import {
} from './styles';

import Module from './Module';
import Project from './Project';
import IdCardForPrint from '../IdCardForPrint';
import ProjectIdCardForPrint from '../ProjectIdCardForPrint';
import { useIdCard } from '../../screens/HomeScreen/context/idCard';

const IdCard = ({ itemData, onAddToLayoutClick }) => {
  const { idCard: idCardData } = itemData;
  const { printMode } = useIdCard();

  const isProjectCard = idCardData && idCardData.hasOwnProperty('integrationYard');

  return printMode ? (
    isProjectCard ?
        <ProjectIdCardForPrint projectId={idCardData?.projectId}/> :
        <IdCardForPrint cardTagId={idCardData?.tagId} />
  ) : (
      isProjectCard ?
        <Project projectData={itemData}/> :
        <Module itemData={itemData} onAddToLayoutClick={onAddToLayoutClick}/>

  );
};

export default IdCard;
